/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState, lazy, useCallback } from 'react';
import { Switch, Redirect, useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ContentRoute, LayoutSplashScreen } from '../../../../_metronic/layout';

import '../../../../_metronic/_assets/sass/pages/users/login-1.scss';
import { lineLogin, getShopInfo as fetchShopBySeqId } from '../_redux/authCrud';
import * as auth from '../_redux/authRedux';

import { axiosUser } from '@axios/axiosInstances';
import bgImage from '../../../../assets/background-15.png';
import { getTokenBySeqId, setTokenBySeqId } from '../../../utils/localstorage';
import { useIntl } from 'react-intl';
import { useCustomTheme } from '../../../hooks/useCustomTheme';
import '../../../pages/shop-setting/styles.css';

const SocialLogin = lazy(() => import('./socialLogin'));
const CreateBooking = lazy(() => import('../../ECommerce/pages/booking/management/CreateBooking'));
const BookingDetail = lazy(() => import('../../ECommerce/pages/booking/BookingDetail'));
const Registration = lazy(() => import('./Registration'));
const Booking2CreateBookingSelectBranchPage = lazy(() =>
  import('../../ECommerce/pages/bookingV2/createBooking/Booking2CreateBookingSelectBranchPage')
);
const Booking2BookingWorkingDaysPage = lazy(() =>
  import('../../ECommerce/pages/bookingV2/createBooking/Booking2BookingWorkingDaysPage')
);
const Booking2BookingConditionPage = lazy(() =>
  import('../../ECommerce/pages/bookingV2/createBooking/Booking2BookingConditionPage')
);

const Booking2DetailPage = lazy(() => import('../../ECommerce/pages/bookingV2/bookingDetail/Booking2DetailPage'));

const MGM_Detail = lazy(() => import('../../ECommerce/pages/MGM/MGM-Detail/Detail'));
const SharedActivityPage = lazy(() => import('../../ECommerce/pages/funsharing/pages/SharedActivityPage'));

const LiffLogin = lazy(() => import('../../ECommerce/pages/MGM/MGM-Detail/LiffLogin'));
const LiffLoginPage = lazy(() => import('../../ECommerce/pages/funsharing/pages/LiffLoginPage'));

const BookingCreateFlow = lazy(() => import('../../ECommerce/pages/bookingV2/createBooking/BookingCreateFlow'));

export default function AuthPage() {
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const location = useLocation();
  // const search = decodeURIComponent(location.search);
  const search = location.search;
  const queryString = new URLSearchParams(search);
  const isLoginPage = location.pathname.includes('login');
  const isRegistrationPage = location.pathname.includes('registration');
  const isHideSidePane = location.pathname.includes('booking') || location.pathname.includes('mgm');
  const shopId = queryString.get('shop');
  const redeem = queryString.get('redeem');
  const isLineSuccess = queryString.get('line');
  const lineProfile = queryString.get('profile');
  const salesName = queryString.get('sales');
  const refId = queryString.get('refId');
  const mgm = queryString.get('mgm') || window.localStorage.getItem('mgm');
  const referral = queryString.get('referral') || window.localStorage.getItem('referral');
  const branchFriendlyId = queryString.get('branch');
  const inviteCode = queryString.get('invitecode');
  const regcode = queryString.get('regcode');

  const [shopDetail, setShopDetail] = useState(null);
  const dispatch = useDispatch();
  const intl = useIntl();

  const navigateToLoginPage = () => history.push(`/shop/${shopId}/login`);

  if (location.pathname.includes('funsharing')) sessionStorage.setItem('_redirect', location.pathname);

  // Scanned a member's My QR while signed out: remember the Customer Card URL so login
  // returns there instead of the home page (consumed in BasePage after login).
  if (/^\/shop\/\d+\/admin\/customer-card\/[^/]+\/?$/.test(location.pathname)) {
    localStorage.setItem('_customerCard', location.pathname);
  }

  const getLogo = useCallback(async id => {
    const { data } = await fetchShopBySeqId(id);
    dispatch({ type: auth.actionTypes.GetShopInfo, payload: data });
    setShopDetail(data.shop);
  }, []);

  const GetPointandWalletSetting = useCallback(
    async id => {
      let { data } = await axiosUser.get(`/pointandwallet/auth/${id}`);
      dispatch({ type: auth.actionTypes.GetPointandWalletSetting, payload: data });
    },
    [dispatch]
  );
  const GetShopMenuSetting = useCallback(
    async id => {
      let { data } = await axiosUser.get(`/menu/auth/shop/${id}`);
      dispatch({ type: auth.actionTypes.GetShopMenuSetting, payload: data });
    },
    [dispatch]
  );
  const GetCustomerMenuSetting = useCallback(
    async id => {
      let { data } = await axiosUser.get(`/menu/auth/customer/${id}`);
      dispatch({ type: auth.actionTypes.GetCustomerMenuSetting, payload: data });
    },
    [dispatch]
  );
  const GetRegistrationField = useCallback(
    async id => {
      let { data } = await axiosUser.get(`/regis-field/auth/${id}`);
      dispatch({ type: auth.actionTypes.GetRegistrationField, payload: data });
    },
    [dispatch]
  );
  const GetShoppingCustomWordSetting = useCallback(
    async id => {
      let { data } = await axiosUser.get(`/product/auth/custom/${id}`);
      dispatch({ type: auth.actionTypes.GetShoppingCustomWord, payload: data });
    },
    [dispatch]
  );

  const initLine = useCallback(async () => {
    let profile = null;
    try {
      profile = JSON.parse(lineProfile);
      const joinGroupId = window.localStorage.getItem('_joinGroup') || undefined;
      const res = await lineLogin(
        profile.userId,
        shopId,
        profile.pictureUrl,
        profile.email,
        profile.alternativeLineId,
        branchFriendlyId,
        inviteCode,
        joinGroupId
      );
      dispatch({ type: auth.actionTypes.Login, payload: { authToken: res.data.token } });
      dispatch({ type: auth.actionTypes.UserLoaded, payload: { authToken: res.data.user } });
      setTokenBySeqId(shopId, res.data.token);
      if (redeem) {
        history.push({ pathname: `/shop/${shopId}/redeem/${redeem}` });
      }
    } catch (err) {
      let code = localStorage.getItem('_ivc');
      // let sales = localStorage.getItem('_sales');
      let redeem = localStorage.getItem('_redeem');
      localStorage.removeItem('_ivc');
      // localStorage.removeItem('_sales');
      localStorage.removeItem('_redeem');

      let searchStr = '';
      searchStr += code ? `&invitecode=${code}` : '';
      searchStr += salesName ? `&sales=${salesName}` : '';
      searchStr += redeem ? `&redeem=${redeem}` : '';
      searchStr += refId ? `&refId=${refId}` : '';
      searchStr += branchFriendlyId ? `&branch=${branchFriendlyId}` : '';
      searchStr += regcode ? `&regcode=${regcode}` : '';

      setLoading(false);

      if (err.message.includes('404')) {
        history.push({
          pathname: `/shop/${shopId}/registration`,
          search: searchStr,
          profile,
          error: err.message
        });
        return;
      } else if (err.response.data.message === 'User has been suspended') {
        window.alert('User has been suspended, please contact admin');
      } else if (err.response.data.message === 'Branch is not active') {
        window.alert('Branch is not active, please contact admin');
      } else if (err.response.data.message === 'Branches not activated') {
        window.alert('Branches not activated, please contact admin');
      } else if (err.response.data.message === 'User has been Expired') {
        window.alert('User has been Expired, please contact admin');
      } else {
        window.alert(intl.formatMessage({ id: 'alert.error' }));
      }
      navigateToLoginPage();
      console.dir(err);
    }
  }, [
    dispatch,
    shopId,
    history,
    navigateToLoginPage,
    lineProfile,
    redeem,
    intl,
    branchFriendlyId,
    salesName,
    mgm,
    referral
  ]);

  const getShopInfo = useCallback(
    async seqId => {
      let { data } = await fetchShopBySeqId(seqId);
      dispatch({ type: auth.actionTypes.GetShopInfo, payload: data });
    },
    [dispatch]
  );

  useEffect(() => {
    const seqId = window.location.pathname.split('/');
    if (parseInt(seqId[2]) > 0) {
      getLogo(seqId[2]);
      GetPointandWalletSetting(seqId[2]);
      GetShopMenuSetting(seqId[2]);
      GetCustomerMenuSetting(seqId[2]);
      getShopInfo(seqId[2]);
      GetRegistrationField(seqId[2]);
      GetShoppingCustomWordSetting(seqId[2]);
    }

    if (shopId && isLineSuccess) {
      initLine();
    } else {
      setLoading(false);
    }

    const storageToken = getTokenBySeqId(seqId[2]);

    if (storageToken) {
      dispatch({ type: auth.actionTypes.Login, payload: { authToken: storageToken, seqId: seqId[2] } });
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const seqId = window.location.pathname.split('/')[2];

  const customTheme = useCustomTheme();

  function getPreviewImg(base64String) {
    if (!base64String) return null;
    const base64 = base64String.split('data:image/png;base64,')[1];
    const binary = atob(base64);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    const blob = new Blob([new Uint8Array(array)], { type: 'image/png' });
    return `url(${URL.createObjectURL(blob)})`;
  }

  const regisStyle = customTheme?.regis;
  const mainStyle = customTheme?.main;

  const style = isRegistrationPage ? regisStyle : mainStyle;

  const bg = style?.bg ? `url(${style.bg})` : null;

  const wrapperStyle =
    isRegistrationPage || isLoginPage
      ? {
          background: getPreviewImg(style.previewBg) || bg || style.bgColor
        }
      : { backgroundImage: `url(${bgImage})` };

  const GetShopSetting = useCallback(
    async id => {
      const { data } = await axiosUser.get(`/setting/auth/${id}`);
      dispatch({ type: auth.actionTypes.GetShopSetting, payload: data });
    },
    [dispatch]
  );

  const loginPageQueryParams = branchFriendlyId ? `branch=${branchFriendlyId}` : '';

  useEffect(() => {
    if (seqId == null || isNaN(+seqId)) return;

    GetShopSetting(seqId);
    GetPointandWalletSetting(seqId);
    GetShopMenuSetting(seqId);
    GetCustomerMenuSetting(seqId);
    GetRegistrationField(seqId);
    GetShoppingCustomWordSetting(seqId);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <LayoutSplashScreen />;

  return (
    <>
      <div className="d-flex flex-column flex-root">
        <div
          className={`login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid ${
            location.pathname.includes('mgm') ? '' : 'bg-white'
          }`}
          id="kt_login"
        >
          <div
            className="flex-row-fluid d-flex flex-column position-relative p-7 background"
            style={
              isHideSidePane
                ? { background: 'transparent' }
                : {
                    ...wrapperStyle
                  }
            }
          >
            <div className={`d-flex flex-column flex-column-fluid  ${isLoginPage ? 'justify-content-center' : ''}`}>
              {!isHideSidePane && (
                <div className="d-flex flex-column flex-wrap align-items-center flex-center mb-4 mt-lg-0">
                  {shopDetail && shopDetail.logo && (
                    <img
                      alt="Logo"
                      className="img-fluid mx-auto"
                      style={{ maxHeight: isLoginPage ? 200 : 60 }}
                      src={shopDetail.logo.data}
                    />
                  )}
                  {shopDetail && (
                    <h2 style={{ color: regisStyle.shopNameColor, margin: '30px 0 20px 0' }}>{shopDetail.name}</h2>
                  )}
                </div>
              )}
              <div className={`d-flex flex-column ${isHideSidePane && '!align-items-center'} flex-start mt-4 mt-lg-0`}>
                <Switch>
                  {/* <ContentRoute exact path="/oauth-callback" render={WechatLogin} /> */}
                  {/* <ContentRoute exact path="/admin/login" component={Login} />
                  <ContentRoute exact path="/shop/management/login" component={ManagementLogin} />
                  <ContentRoute exact path="/shop/management" component={Management} />
                  <ContentRoute exact path="/shop/management/announcement" component={AnnouncementsPage} />
                  <ContentRoute exact path="/shop/management/announcement/new" component={AnnouncementEdit} />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:editType"
                    component={AnnouncementPopupNotifyEdit}
                  />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:editType"
                    component={AnnouncementPopupNotifyEdit}
                  />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:announcementId/edit/:editType"
                    component={AnnouncementPopupNotifyEdit}
                  />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:announcementId/edit/:editType"
                    component={AnnouncementPopupNotifyEdit}
                  />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:announcementId/edit"
                    component={AnnouncementEdit}
                  />
                  <ContentRoute
                    exact
                    path="/shop/management/announcement/:announcementId/delete"
                    component={AnnouncementsPage}
                  />
                  <ContentRoute exact path="/shop/management/feature-package/new" component={FeaturePackageEditPage} />
                  <ContentRoute
                    path="/shop/management/feature-package/:featurePackageId"
                    component={FeaturePackageEditPage}
                  />
                  <ContentRoute exact path="/shop/management/openapi/user/create" component={OpenApiUserEdit} />
                  <ContentRoute exact path="/shop/management/openapi/token/new" component={OpenapiTokenCreate} />
                  <ContentRoute exact path="/shop/management/openapi/user/:openapiUserId" component={OpenApiUserEdit} /> */}
                  <ContentRoute exact path="/shop/:seqId/login" component={SocialLogin} />
                  <ContentRoute exact path="/shop/:seqId/applyInvite" component={SocialLogin} />
                  <ContentRoute exact path="/shop/:seqId/registration" component={Registration} />
                  <ContentRoute exact path="/shop/:seqId/booking" component={CreateBooking} />
                  <ContentRoute exact path="/shop/:seqId/booking/:bookingId/detail" component={BookingDetail} />
                  <ContentRoute
                    key={'create-branch'}
                    exact
                    path="/shop/:shopId/booking2-createbooking/"
                    component={Booking2CreateBookingSelectBranchPage}
                  />
                  <ContentRoute
                    key={'create-workingdays'}
                    path="/shop/:shopId/booking2-createbooking/:branchId/workingdays"
                    component={Booking2BookingWorkingDaysPage}
                  />
                  <ContentRoute
                    key={'create-condition'}
                    path="/shop/:shopId/booking2-createbooking/:branchId/condition"
                    component={Booking2BookingConditionPage}
                  />
                  <ContentRoute
                    key={'booking-create'}
                    path="/shop/:shopId/booking2-createbooking/:branchId"
                    component={BookingCreateFlow}
                  />
                  <ContentRoute
                    key={'booking-detail'}
                    path="/shop/:shopId/booking2/:bookingId/detail"
                    component={Booking2DetailPage}
                  />
                  <ContentRoute exact path="/liff-login" component={LiffLogin} />
                  <ContentRoute exact path="/shareTarget" component={MGM_Detail} />

                  {/* <ContentRoute exact path="/liff-login" component={LiffLoginPage} /> */}
                  <ContentRoute exact path="/funsharing" component={SharedActivityPage} />

                  <Redirect from="/admin" to="/admin/login" />
                  <Redirect from="/shop/:seqId" to={`/shop/${seqId}/login?${loginPageQueryParams}`} />
                  <Redirect to="/error" />
                </Switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
